import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import useStyles from "./styles";
import { formatCalendarDate, disabledDate } from "../shared/dateFormat";

export const FormInput = ({
  id,
  name,
  size,
  type,
  onChange,
  className,
  value,
  error,
  children,
  fullWidth,
  disabled,
  editable,
  ammend,
  variant,
  rows,
  multiline,
  isTrim,
  onBlur,
  minLength,
  maxLength = 1000,
  onClick,
  dateDisable,
  min,
  required,
  isNumber,
  helpText,
  autoFocus,
  autocomplete,
  placeholder,
  upperCaseAllow,
  title,
  rangeAllowed,
  floatNumberAllow = false,
  onKeyDown = () => {},
  onKeyUp = () => {},
  onKeyPress = () => {},
  inputProps,
  ...props
}) => {
  const classes = useStyles();
  const [defaultValue, setDefaultValue] = useState("");
  const [localError, setLocalError] = useState(false);
  useEffect(() => {
    setDefaultValue(value !== "" || value !== null ? value : "");
    setLocalError(error);
  }, [value]);

  /**
   *
   * @param {*} e
   */
  const handleOnBlur = (e) => {
    if (required && e.target.value === "") {
      setLocalError(true);
    } else {
      setLocalError(false);
      if (onBlur) onBlur(e);
    }
  };
  const handleOnChange = (e) => {
    if (isTrim) {
      e.target.value = e.target.value.trim("");
    }

    if (isNumber) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      if (rangeAllowed) {
        if (e.target.value > 100) {
          return true;
        }
      }
    } else if (floatNumberAllow) {
      let val = e.target.value;
      let temp = val.split(".");
      if (temp.length > 2) {
        return true;
      } else if (temp.length === 2) {
        if (temp[1].length >= 3) {
          return true;
        }
      }
    } else if (e.target.value) {
      e.target.value = e.target.value.toUpperCase();
    }
    if (e.target.value.length > parseInt(maxLength)) {
      return true;
    }
    if (required && e.target.value === "") {
      setLocalError(true);
      setDefaultValue("");
    } else {
      setLocalError(false);
      if (onChange) onChange(e);
      setDefaultValue(e.target.value);
    }
  };
  return (
    <React.Fragment>
      <TextField
        autoComplete={"off"}
        autoCorrect={"off"}
        id={id}
        type={type}
        size={size}
        name={name}
        value={
          type === "date" ? formatCalendarDate(defaultValue) : defaultValue
        }
        onChange={handleOnChange}
        fullWidth={fullWidth}
        multiline={multiline}
        rows={rows}
        variant={variant}
        disabled={disabled}
        onBlur={handleOnBlur}
        minLength={minLength}
        maxLength={maxLength}
        required={required}
        onClick={onClick}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        className={className}
        classes={{
          root: error
            ? classes.error
            : disabled
            ? classes.disabledInput
            : classes.editableInput,
        }}
        InputProps={{
          ...inputProps,
          classes: {
            // input: classes.formProperties,
            // root: disabled ? classes.disabledInput : classes.editableInput,
          },
          min: type === "date" && dateDisable ? disabledDate() : null,
          maxLength: maxLength,
        }}
        error={localError}
        helperText={helpText}
        title={title}
      />
      {error ? (
        <span
          style={{
            color: "red",
          }}
        >
          {/* {validationMessage.required} */}
        </span>
      ) : null}
    </React.Fragment>
  );
};

FormInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(["text", "number", "password", "date", "email"]),
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};
